import {SportModel} from "../../model";

export const urls = {
  home: "/quiz/",
  list: "/quiz/sports",
}

export const ListBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Sports",
    url: "#"
  }
];


export const CreateBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Sports",
    url: urls.list
  },
  {
    label: "Create",
    url: '#'
  }
];

export const EditBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Sports",
    url: urls.list
  },
  {
    label: "Edit",
    url: '#'
  }
];

export interface IState {
  id: number;
  sport: SportModel;
}